<template>
  <div class="contact-banner">
    <div class="contact-left">
      <h2 class="contact-title">{{ $t("home.contactForm.title") }}</h2>
      <p class="contact-subtitle">{{ $t("home.contactForm.subtitle") }}</p>
    </div>
    <div class="contact-middle">
      <div class="contact-qr">
        <img :src="reviewLogo" alt="QR" />
      </div>
      <p class="contact-line">{{ $t("home.contactForm.email") }}</p>
      <p class="contact-line">{{ $t("home.contactForm.whatsapp") }}</p>
      <div class="contact-deco" aria-hidden="true">
        <i class="el-icon-location-outline contact-deco-pin"></i>
        <span class="contact-deco-line"></span>
        <i class="el-icon-s-promotion contact-deco-plane"></i>
      </div>
    </div>
    <form class="contact-form" @submit.prevent="submitContactForm">
      <div class="form-row-top">
        <input
          v-model="contactForm.name"
          type="text"
          class="contact-input"
          :placeholder="$t('home.contactForm.namePlaceholder')"
        />
        <button
          type="submit"
          class="contact-submit"
          :disabled="contactSubmitting"
        >
          {{ $t("home.contactForm.submit") }}
          <span>{{ $t("home.contactForm.submitArrow") }}</span>
        </button>
      </div>
      <input
        v-model="contactForm.email"
        type="email"
        class="contact-input"
        :placeholder="$t('home.contactForm.emailPlaceholder')"
      />
      <input
        v-model="contactForm.phone"
        type="tel"
        class="contact-input"
        :placeholder="$t('home.contactForm.phonePlaceholder')"
      />
      <textarea
        v-model="contactForm.message"
        class="contact-input contact-textarea"
        rows="4"
        :placeholder="$t('home.contactForm.messagePlaceholder')"
      ></textarea>
      <p class="contact-form-hint">
        {{ $t("home.contactForm.submitHint") }}
      </p>
    </form>
  </div>
</template>

<script>
export default {
  name: "ContactFormBanner",
  data() {
    return {
      contactForm: {
        name: "",
        email: "",
        phone: "",
        message: "",
      },
      contactSubmitting: false,
    };
  },
  computed: {
    reviewLogo() {
      return require("@/assets/logo/qr.jpg");
    },
  },
  methods: {
    submitContactForm() {
      const { name, email, phone, message } = this.contactForm;
      if (!name.trim() || !email.trim() || !message.trim()) {
        this.$message.warning(this.$t("home.contactForm.required"));
        return;
      }
      this.contactSubmitting = true;
      this.$api
        .addContact({
          name: name.trim(),
          email: email.trim(),
          companyName: "",
          mobile: phone.trim(),
          consultationContent: message.trim(),
          code: "",
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success(this.$t("home.contactForm.submitSuccess"));
            this.contactForm = { name: "", email: "", phone: "", message: "" };
            this.$emit("submitted");
          } else {
            this.$message.error(
              res.msg || this.$t("home.contactForm.submitFail")
            );
          }
        })
        .catch(() => {
          this.$message.error(this.$t("home.contactForm.submitFail"));
        })
        .finally(() => {
          this.contactSubmitting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-banner {
  width: 100%;
  padding: 48px 50px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 32px;
  background: linear-gradient(145deg, #ffc04d 0%, #ff8c00 48%, #f07800 100%);
  border-radius: 16px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  box-shadow: 0 16px 48px rgba(255, 140, 0, 0.28),
    0 6px 20px rgba(0, 0, 0, 0.08);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    pointer-events: none;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.45),
      inset 0 -2px 8px rgba(0, 0, 0, 0.06);
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.18) 0%,
      rgba(255, 255, 255, 0.04) 28%,
      transparent 55%,
      rgba(0, 0, 0, 0.05) 100%
    );
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.5) 20%,
      rgba(255, 255, 255, 0.5) 80%,
      transparent
    );
    pointer-events: none;
  }
}

.contact-left {
  flex: 0 0 220px;
  color: #fff;
  position: relative;
  z-index: 2;
}

.contact-title {
  margin: 0 0 16px;
  font-size: 36px;
  font-weight: 700;
  line-height: 1.2;
}

.contact-subtitle {
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  opacity: 0.95;
}

.contact-middle {
  flex: 0 0 200px;
  color: #fff;
  font-size: 13px;
  line-height: 1.6;
  position: relative;
  z-index: 2;
}

.contact-qr {
  width: 88px;
  height: 88px;
  margin-bottom: 44px;
  padding: 6px;
  background: #fff;
  border-radius: 6px;
  box-sizing: border-box;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.contact-line {
  margin: 0 0 6px;
}

.contact-deco {
  position: absolute;
  left: 50%;
  top: 55%;
  width: 280px;
  transform: translate(-30%, -50%);
  display: flex;
  align-items: center;
  pointer-events: none;
  z-index: 1;
  opacity: 0.35;
}

.contact-deco-pin {
  font-size: 18px;
  color: #fff;
}

.contact-deco-line {
  flex: 1;
  height: 0;
  margin: 0 8px;
  border-top: 2px dashed rgba(255, 255, 255, 0.8);
}

.contact-deco-plane {
  font-size: 20px;
  color: #fff;
  transform: rotate(15deg);
}

.contact-form {
  flex: 1;
  min-width: 0;
  max-width: 420px;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row-top {
  display: flex;
  align-items: stretch;
  gap: 16px;
}

.contact-input {
  width: 100%;
  padding: 12px 14px;
  font-size: 14px;
  color: #333;
  background: #fff;
  border: none;
  border-radius: 6px;
  box-sizing: border-box;
  outline: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.95),
    inset 0 -1px 2px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.25s ease;

  &:focus {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.14),
      inset 0 1px 0 rgba(255, 255, 255, 1), inset 0 -1px 2px rgba(0, 0, 0, 0.05);
  }

  &::placeholder {
    color: #999;
  }
}

.form-row-top .contact-input {
  flex: 1;
  margin-bottom: 0;
}

.contact-textarea {
  resize: vertical;
  min-height: 110px;
  font-family: inherit;
}

.contact-submit {
  flex-shrink: 0;
  padding: 0 22px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(180deg, #2a2a2a 0%, #1a1a1a 100%);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.12);
  transition: opacity 0.3s, box-shadow 0.25s ease, transform 0.25s ease;

  span {
    margin-left: 4px;
  }

  &:hover:not(:disabled) {
    opacity: 0.92;
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.15);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.contact-form-hint {
  margin: 4px 0 0;
  padding-top: 4px;
  font-size: 12px;
  color: #fff;
  text-align: right;
  opacity: 0.9;
}

@media (max-width: 992px) {
  .contact-banner {
    flex-direction: column;
    padding: 32px 24px;
  }

  .contact-left,
  .contact-middle,
  .contact-form {
    flex: none;
    width: 100%;
    max-width: 100%;
  }

  .contact-deco {
    display: none;
  }

  .form-row-top {
    flex-direction: column;
  }

  .contact-submit {
    width: 100%;
    padding: 12px;
  }

  .contact-form-hint {
    text-align: left;
  }
}
</style>
